// 部署到服务器时改为生产地址
// var serverUrl = "https://api.inforsurf.cn"
var serverUrl = "https://api.inforsurf.cn"
export default serverUrl
